import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";

function TitleSelector() {
  const { t } = useTranslation();

  const titles = {
    "/dashboards/dataquality": {
      title: "Data Quality",
      subText: "Tool to analyze data quality and identify data issues.",
    },
    "/trafficmonitoring/monitoring": {
      title: "Traffic Monitoring",
      subText: "Real-time collection and analysis of data",
    },
    "/trafficmonitoring/historical_monitoring": {
      title: "Traffic Monitoring",
      subText: "Historical collection and analysis of data",
    },
    "/dashboards/mfd": {
      title: "MFD",
      subText: "Macroscopic Fundamental Diagrams for 10 Areas",
    },
    "/dashboards/routeFlows": {
      title: "Route Flows",
      subText: "Number of vehicles per intersection across corridors ",
    },
    "/dashboards/intersection": {
      title: "Intersection",
      subText: "Real-time flow and turn ratio values per approach per intersection",
    },
    "/dashboards/detectorslist": {
      title: "Data Quality Detectors List",
      subText: "A complete list of detectors available in the system.",
    },
    "/notifications/create": {
      title: "Create Alert",
      subText: "Form that creates alerts to receive notifications.",
    },
    "/notifications/show": {
      title: "Alerts List",
      subText: "A complete list of alerts created in the system.",
    },
    "/trajectories": {
      title: "Trajectories analytics",
      subText: t("trajectories.subtitle"),
    },
    "/events/create": {
      title: "Event Management",
      subText: "Create event",
    },
    "/events/show": {
      title: "Event Management",
      subText: "Events library",
    },
    "/sumo/create": {
      title: "SUMO",
      subText: "Create SUMO scenario.",
    },
    "/sumo/show": {
      title: "SUMO List",
      subText: "A complete list of SUMO ran in the system.",
    },
  };

  const location = useLocation();
  useEffect(() => {}, [location.pathname]);
  return (
    <MDBox p={3} lineHeight={1}>
      <MDTypography variant="h5" fontWeight="medium">
        {titles[location.pathname]?.title || ""}
      </MDTypography>
      <MDTypography variant="button" color="text">
        {titles[location.pathname]?.subText || ""}
      </MDTypography>
    </MDBox>
  );
}

export default TitleSelector;
